import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthenticationService } from "../../../core/authentication/authentication.service";
import { parseJwt } from "../../../core/jwt/jwt.util";
import { LoadingService } from "../../../core/loader/loading.service";
import { NotificationService } from "../../../shared/components/notification/notification.service";
import { LoginLayoutData } from "../index-layout/index-layout.type";

const INVALID_TOKEN_ERROR = "Your link is not valid. Please contact support";
const SUCCESS_CONFIRMED_MESSAGE = "Your account was successfully confirmed";
const ALREADY_CONFIRMED_MESSAGE = "Your account was already confirmed";

@Component({
  selector: "app-confirm-account",
  templateUrl: "./confirm-account.component.html",
  styleUrls: ["./confirm-account.component.css"],
})
export class ConfirmAccountComponent implements OnInit {
  token: string;
  loading$ = this.loader.loading$;
  layoutData: LoginLayoutData = {
    image: "assets/ChannelWorks-Logo.png",
    instructions: "Click here to login if you are not automatically redirect",
    imageStyles: {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      "max-width": "250px",
    },
    headerLink: "/login",
  };

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthenticationService,
    private loader: LoadingService,
    private notificationService: NotificationService,
  ) {
    this.loader.show();
  }

  ngOnInit(): void {
    this.token = this.route.snapshot.queryParams["code"];
    try {
      parseJwt(this.token);
    } catch (err) {
      this.handleError();
    }

    this.authService
      .confirmAccount(this.token, { skipFilter: true })
      .subscribe(
        (response: { confirmed: boolean }) => {
          const message = response.confirmed ? SUCCESS_CONFIRMED_MESSAGE : ALREADY_CONFIRMED_MESSAGE;
          this.notificationService.success(message);
          this.router.navigate(["/login"]);
        },
        (err) => {
          const message = err && err.message;
          this.handleError(message);
        },
      )
      .add(() => {
        this.loader.hide();
      });
  }

  private handleError(message?: string): void {
    this.notificationService.error(message || INVALID_TOKEN_ERROR);
    this.loader.hide();
    this.router.navigate(["/login"]);
  }
}
